import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {useIntl} from "react-intl";
import router from "@/routing/Router";
import JobApplicationsPageHeadingActions from "./JobApplicationsPageHeadingActions";
import {SetURLSearchParams} from "react-router-dom";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";
import {JobApplicationsFilterStatus} from "@widgets/jobApplications/overview/JobApplications";


type Props = {
    statusFilter: JobApplicationsFilterStatus;
    setSearchParams: SetURLSearchParams;
};

const JobApplicationsPageHeading = ({statusFilter, setSearchParams}: Props) => {
    const intl = useIntl();
    const route = router.jobApplications;

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={route.name(intl)}
            actionRow={
                <JobApplicationsPageHeadingActions
                    statusFilter={statusFilter}
                    setSearchParams={setSearchParams}
                />
            }
            meta={<LocationPageMeta/>}
            actionRowHorizontal={false}
            breakpoints={{md: {actionRowHorizontal: true}}}
        />
    );
};

export default JobApplicationsPageHeading;